// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export default {
	page_title: "Réservation",
	navbar_tab_1: "Avion",
	navbar_tab_2: "Options & Assurances",
	navbar_tab_3: "Coordonnées",
	navbar_tab_4: "Paiement",
	step: "ÉTAPE",
	you_accommodation: "VOTRE HEBERGEMENT",
	adult: "adulte",
	Adult: "Adulte",
	adults: "adultes",
	Adults: "Adultes",
	child: "Enfant",
	Child: "Enfant",
	children: "enfants",
	Children: "Enfants",
	age: "âge",
	ages: "âges",
	mister: "M.",
	madam: "Mme",
	see_more: "Voir plus",
	see_less: "Fermer",
	yes: "Oui",
	no: "Non",
	see_more_options: "Voir plus d’options",
	more_infos: "Plus d’infos",
	images_copyright: "Photos non contractuelles",
	day_monday: "lundi",
	day_tuesday: "Mardi",
	day_wednesday: "Mercredi",
	day_thursday: "Jeudi",
	day_friday: "Vendredi",
	day_saturday: "Samedi",
	day_sunday: "Dimanche",
	month_january: "janvier",
	month_february: "février",
	month_march: "mars",
	month_april: "avril",
	month_may: "mai",
	month_june: "juin",
	month_july: "juillet",
	month_august: "août",
	month_september: "septembre",
	month_october: "octobre",
	month_november: "novembre",
	month_december: "décembre",
	options_modify: "Personnaliser",
	options_modify_panel: "Modifier",
	options_panel_title_modify: "Modifiez les",
	options_panel_title_modify_la: "Modifiez la",
	options_panel_title_modify_for_1: "Modifiez le",
	options_panel_title_modify_for_2: "de",
	options_add: "Ajouter",
	options_included: "Inclus",
	options_day: "jour",
	options_days: "jours",
	options_days_2: "journées",
	options_from: "du",
	options_to: "au",
	options_validate_selection: "Validez votre sélection",
	validate_for_all_participants: "Validez votre sélection pour tous les participants",
	options_removed: "retiré du package",
	options_error_sorry: "Désolé,",
	options_error_default_service: "ce service",
	options_error_not_available: "n’est plus disponible.",
	options_no_service_selected: "Aucun service sélectionné",
	options_no_service_selected_1: "Aucun",
	options_no_service_selected_2: "sélectionné",
	options_no_skipass: "Aucun skipass sélectionné",
	options_no_equipment: "Aucun matériel de ski sélectionné",
	options_no_transport: "Aucun transport sélectionné",
	options_no_esf: "Ancun cours de ski sélectionné",
	options_no_food: "Aucun panier repas sélectionné",
	options_no_insurance_skier: "Aucune assurance skieur sélectionnée",
	options_no_hotel_service: "Aucun service hôtelier sélectionné",
	options_15_cancellation: "Inclus : Annulation gratuite  jusqu’à 15 jours avant le séjour",
	options_45_cancellation: "Annulation gratuite de 100% du séjour jusqu’à J-40*",
	options_45_cancellation_under_sentence: "*Pour en savoir plus, consultez nos CGV",
	options_who_departs: "Participants",
	options_please_fill_participants: "Veuillez renseigner les noms, prénoms et âges de chaque participant au début du séjour.",
	options_fill_names: "Veuillez renseigner les noms, prénoms et âges de chaque participant pour profiter des meilleurs tarifs.",
	options_participant: "Participant",
	options_years: "ans",
	options_years_and_more: "et plus",
	options_age_at_start: "Age du participant le jour du voyage",
	options_first_name: "Prénom",
	options_lastname: "Nom",
	options_travelers_error_message: "Veuillez renseigner les noms, prénoms et âges de chaque participant",
	options_prepare_your_voyage: "Personnalisez votre séjour",
	options_select_your_insurances: "Sélectionnez vos assurances",
	options_change_traveler_age: "Modifier l’âge du participant remettra à zéro toutes ses options.",
	options_change_traveler_age_confirmation: "L’âge des participants suivants a été mis à jour, toutes leurs options ont été remises à zéro",
	options_change_traveler_age_updated: "Les informations des participants ont été mises à jour",
	options_I_understood: "J’ai compris",
	options_skipass: "Skipass",
	options_no_skipass_selected: "Pas de skipass sélectionné",
	options_km_ski_slopes: "km de pistes",
	options_of_tracks: "de pistes",
	options_remove_skipass_1: "Si vous retirez cette option de votre package, un montant de",
	options_remove_skipass_2: "sera conservé",
	options_no_queues: "Réservez vos forfaits et récupérez-les lors de la remise des clés",
	options_skipass_blue_sentence: "Économisez du temps et de l’argent",
	options_equipment: "Matériel de ski",
	options_select_level: "Sélectionnez la gamme de matériel",
	criteria_997: "Économique",
	criteria_998: "Argent",
	criteria_999: "Or",
	criteria_1000: "Platine",
	criteria_1031: "Espoir",
	criteria_1030: "Champion",
	options_no_equipment_selected: "Pas de matériel de ski sélectionné",
	options_enjoy_skiing_at_arrival_1: "Retirez votre matériel au magasin",
	options_enjoy_skiing_at_arrival_2: "situé à",
	options_enjoy_skiing_at_arrival_3: "mètres de votre hébergement !",
	options_helmet: "Casque",
	options_shoes: "Chaussures",
	options_sticks: "Bâtons",
	options_equipment_blue_sentence: "Gagnez en proximité et sérénité",
	options_transport: "Transport",
	options_enjoy_skiing_at_arrival: "Profitez du ski dès votre arrivée !",
	options_distance_from_ski_shop_1: "La boutique",
	options_distance_from_ski_shop_2: "se situe à",
	options_distance_from_ski_shop_3: "de votre hébergement !",
	options_distance_from_ski_shop_4: "se situe dans le même bâtiment que votre hébergement !",
	options_add_transport: "Ajouter un transport",
	options_add_transport_for: "Ajouter un transport pour",
	options_delete_transport: "Supprimer le transport",
	options_transport_first_date: "Aller",
	options_transport_second_date: "Retour",
	options_package_travelski: "Package Travelski :",
	options_train_plus_shuttle: "train + navette. Souciez-vous uniquement de vos vacances au ski en famille !",
	options_no_transport_selected: "Pas de transport sélectionné",
	options_choose_a_go: "Choisissez votre aller",
	options_choose_a_return: "Choisissez votre retour",
	options_departure_station: "Gare de départ",
	options_arrival_station: "Gare d’arrivée",
	options_one_way_option: "Options",
	options_i_travel_in: "Je voyage en :",
	options_my_transfer: "Mon transfert",
	options_transport_summary_for: "Récapitulatif du transport pour",
	options_total_transport: "Total du transport",
	options_transit_time: "de correspondance",
	options_estimated_time: "Estimé à",
	options_information: "Informations",
	train: "tarin",
	criteria_1039: "1ère classe",
	criteria_1040: "2nde classe",
	shuttle: "Navette",
	taxi: "Taxi",
	baggage_cabin: "Bagage cabine",
	backpack: "Sac à dos",
	wifi: "Wifi",
	meal: "Repas",
	dinner: "Dîner",
	options_how_to_choose_title: "Comment choisir un cours adapté à mon niveau de ski ?",
	options_ski_lesson: "Cours de ski",
	options_take_esf: "Sélectionnez un cours",
	options_course_on: "Cours sur",
	options_how_i_choose_lesson: "Choisissez un cours collectif adapté à votre niveau du ski",
	options_beginner: "Débutant",
	options_piou_piou: "Piou-Piou",
	criteria_992: "Ourson",
	criteria_993: "Flocon",
	criteria_994: "1ère étoile",
	criteria_995: "2ème étoile",
	criteria_996: "3ème étoile",
	options_no_course_selected: "Pas de cours sélectionné",
	options_content_piou_piou: "Je veux goûter aux plaisirs de la neige et tenter mes premières glissades à skis.",
	options_content_ourson_title: "Je n’ai jamais skié",
	options_content_ourson: "Je veux faire mes 1ères descentes à ski en chasse neige et apprendre à faire des virages.",
	options_content_flocon_title: "J’ai eu mon Ourson",
	options_content_flocon: "J’ai envie d’aller sur les pistes et faire de grands virages plus vite.",
	options_content_1_star_title: "J’ai eu mon flocon",
	options_content_1_star: "Je tourne en chasse-neige et je prends le téléski tout seul.",
	options_content_2_star_title: "J’ai réussi ma première étoile. Je skie un peu partout sur les pistes faciles.",
	options_content_2_star: "J’aimerai apprendre à déraper et à tourner les skis presque parallèles pour aller sur les grandes pistes.",
	options_content_3_star_title: "J’ai obtenu ma 2ème étoile",
	options_content_3_star: "Je dois perfectionner mon virage parallèle et mes dérapages pour être super à l’aise tout en allant plus vite.",
	options_content_adulte_beginner_title: "Je ne sais pas skier",
	options_content_adulte_beginner: "Je souhaite apprendre à garder l’équilibre, contrôler ma vitesse, faire des virages en chasse-neige et utiliser les remontées mécaniques.",
	options_adults_beginner: "Adultes - ski débutant",
	options_watch_video: "Voir la vidéo",
	options_back_to_choices: "Revenez aux choix du participant",
	options_age_group_1: "3 à 4 ans",
	options_age_group_2: "4 à 5 ans",
	options_age_group_3: "6 à 12 ans",
	options_age_group_4: "13 ans et plus (Adultes)",
	options_food: "Panier repas",
	options_take_food: "Sélectionnez un panier repas",
	options_take_food_for: "Sélectionnez un panier repas pour",
	options_catering: "Paniers de courses livrés",
	options_catering_delivery: "Vos paniers de courses livrés le jour de votre arrivée",
	options_no_food_selected: "Pas de panier repas sélectionné",
	options_see_menu: "Voir le menu",
	options_restaurant: "Restauration",
	options_catering_services: "Des services de restauration adaptés à vos envies",
	options_facilitate_arrival: "Faciliter votre arrivée en réservant vos services",
	options_reserve_your_services: "Réservez vos services",
	options_take_accommodation_services: "Sélectionnez vos services hôteliers",
	options_book_services: "Réservez vos services",
	options_book_services_easy: "Facilitez votre arrivée en réservant vos services",
	options_insurance: "Assurance",
	options_take_insurance: "Souscrivez à l’assurance skieur",
	options_no_insurance_selected: "Pas d’assurance sélectionnée",
	options_insurance_advantages: "Les avantages de l’assurance skieur",
	options_per_pers: "pers",
	options_breakage_theft: "Bris & vols du matériel de ski personnel ou de location",
	options_rescue_research: "Frais de secours et recherche sur les pistes",
	options_hospitalization: "Frais médicaux et d’hospitalisation (hors sécurité sociale)",
	options_repatriation: "Frais de rapatriement",
	options_interruption_stay: "Frais d’interruption de séjour et de remboursement des prestations non utilisées",
	options_snow_guarantee: "Garantie neige",
	options_insurance_annulation: "Assurance annulation de séjour",
	options_per_booking: "dossier",
	options_cancellation: "Annulation possible jusqu’à la veille du départ",
	options_reimbursement: "Remboursement en chèque ou virement en cas de motif justifié",
	options_credit_note: "Couvre les cas exclus par les cartes bancaires",
	options_coverage_price: "Bon d’achat valable 12 mois en cas de motif non justifié",
	options_insurance_annulation_no: "Je ne souscris pas l’assurance",
	options_insurance_annulation_yes: "Je souscris l’assurance",
	options_insurance_slogan: "Soyez couverts pendant votre séjour",
	options_person: "personne",
	options_free: "Gratuit",
	commercial_discount: "Remise commerciale",
	log_in_or_register: "Connectez-vous ou inscrivez-vous pour réserver",
	login_register: "Continuer",
	email_not_valid: "Votre adresse e-mail est incorrecte",
	user_info_mandatory_field: "Champ obligatoire",
	user_info_invalid_phone: "Format invalide. Le numéro de téléphone doit contenir 10 chiffres.",
	new_password_forgot_password: "Mot de passe oublié ?",
	new_password_create_new_password: "Créez votre nouveau mot de passe",
	new_password1: "Nouveau mot de passe",
	new_password2: "Confirmer votre mot de passe",
	user_info_forgot_password: "Mot de passe oublié ?",
	user_info_already_have_account: "Vous avez déjà un compte ?",
	user_info_enter_email: "Cliquez sur Envoyer pour réinitialiser votre mot de passe",
	user_info_email_sent: "Un lien pour réinitialiser votre mot de passe a été envoyé à",
	user_info_new_password: "Indiquez votre nouveau mot de passe",
	send: "Envoyer",
	validate: "Valider",
	i_want_to_register: "Je veux créer un compte",
	i_want_to_login: "Je veux me connecter",
	new_password_succes: "Votre mot de passe a été réinitialisé avec succès",
	login: "On s’est déjà croisé sur les pistes ?",
	registration_or_login: "Créez un compte ou connectez-vous à votre compte",
	save_booking: "Enregistrez votre réservation dans votre compte et gagnez en rapidité.",
	user_info_your_informations: "Vos informations",
	contacts_first_name: "Prénom",
	contacts_last_name: "Nom",
	contacts_email: "E-mail",
	contacts_other_email: "Se connecter avec un autre e-mail",
	contacts_password1: "Mot de passe",
	contacts_password2: "Confirmez votre mot de passe",
	contacts_password_format: "Votre mot de passe doit",
	contacts_password_format_lenght: "Contenir au minimum 8 caractères",
	contacts_password_format_lowercase: "Contenir au moins 1 minuscule",
	contacts_password_format_uppercase: "Contenir au moins 1 majuscule",
	contacts_password_format_number: "Contenir au moins 1 chiffre",
	contacts_password_format_character: "Contenir au moins 1 caractère spécial (# ; @ ; \$ ...)",
	contacts_passwords_dont_match: "Le mot de passe ne correspond pas",
	contacts_email_is_not_valid: "L’e-mail n’est pas valide",
	user_info_to_contact_you: "Vous joindre",
	contacts_address: "Adresse",
	contacts_city: "Ville",
	contacts_country: "Pays",
	contacts_postal_code: "Code postal",
	contacts_phone_number: "00 00 00 00 00",
	contacts_subscribe_newsletter: "Je m’abonne à la Newsletter de Travelski.com et je profite des promotions, ventes flash et avantages fidélité !",
	opt_in_offers: "J’accepte de recevoir des offres exclusives, idées de séjour et actualités de travelski",
	opt_in_quote: "J’accepte d’être contacté si je sauvegarde ma recherche sur le site travelski",
	opt_in_quote_payment: "J’accepte d’être contacté dans le cadre d’une recherche que je vais sauvegarder",
	personal_data_1: "Pour en savoir plus sur la façon dont travelski utilise et protège vos données personnelles,",
	personal_data_2: "cliquez ici",
	personal_data_3: ". Vous pouvez vous désinscrire gratuitement et à tout moment",
	contacts_accept_conditions_1: "J’ai lu et j’accepte les",
	contacts_accept_conditions_2: "Conditions Générales de Vente",
	contacts_accept_conditions_3: "et je suis informé de l’absence de droit de rétractation.",
	update_my_details: "Mettre à jour mes coordonnées",
	continue_with_these_contacts: "Continuer avec ces informations",
	save_registration: "Enregistrer",
	user_info_lihe_more_details: "Plus de détails",
	user_info_create_account: "Créez un compte",
	user_info_is_it_first_time: "Vous partez avec Travelski pour la 1ère fois ?",
	error_wrong_email: "L’adresse e-mail saisie est invalide. Veuillez vérifier l’e-mail renseigné et réessayer.",
	payment_my_account: "Mon compte",
	payment_choose_method: "Passer au paiement",
	proceed_to_payment: "Passer au paiement",
	payment_by_credit_card: "Paiement par carte bancaire",
	flex_product: "Flex",
	payment_credit_card_payment_condition_1_desc_1: "Vous avez choisi une offre Flex. Nous procédons ce jour au débit de",
	payment_credit_card_payment_condition_1_desc_2: "correspondant à",
	payment_credit_card_payment_condition_1_desc_3: "du montant de votre commande.",
	payment_credit_card_payment_condition_1_desc_4: "Le solde, soit",
	payment_credit_card_payment_condition_1_desc_5: ", sera prélevé automatiquement le",
	payment_credit_card_payment_condition_1_notice_1: "30% d’acompte à la commande, modification gratuite jusqu’au",
	payment_credit_card_payment_condition_1_notice_1_2: "(hors frais de dossier et assurances souscrites)",
	payment_credit_card_payment_condition_1_notice_2_2: ". Modification des prestations hors hébergements selon les",
	payment_credit_card_payment_condition_1_notice_2_3: "conditions générales de vente.",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_1: "Vous avez choisi une offre Flex. Nous procédons ce jour au débit de",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_2: "correspondant à",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_3: "du montant de votre commande.",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_4: "Le solde, soit",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_5: ", sera prélevé automatiquement le",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_1: "30% d’acompte à la commande, modification gratuite jusqu’au",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_2: "(hors frais de dossier et assurances souscrites). Modification des prestations hors hébergements selon les",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_3: "conditions générales de vente.",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_1: "Vous avez choisi une offre Flex. Nous procédons ce jour au débit de",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_2: ", correspondant à 100% du montant de votre commande.",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_3: "Annulation et modification gratuites jusqu’au",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_4: "(hors frais de dossier et assurances souscrites). Modification des prestations hors hébergements selon les",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_5: "conditions générales de vente.",
	payment_credit_card_payment_condition_1_notice_PV_after_deposit_1: "Paiement total à la commande.",
	fix_product: "Fixe",
	payment_credit_card_payment_condition_2_desc_1: "Vous avez choisi une offre Fixe. Nous procédons ce jour au débit de",
	payment_credit_card_payment_condition_2_desc_2: ", correspondant à 100% du montant de votre commande.",
	payment_credit_card_payment_condition_2_desc_3: "Non remboursable. Modification des prestations hors hébergements selon les",
	payment_credit_card_payment_condition_2_desc_4: "conditions générales de vente.",
	payment_credit_card_payment_condition_2_notice_1: "Paiement total à la commande. Non remboursable.",
	card_number: "Numéro de carte",
	credit_card_date: "MM/AA",
	cvc: "CVC",
	where_find_cvc: "Où trouver mon CVC ?",
	cvc_popup_title: "Où trouver votre code de vérification ?",
	cvc_popup_desc: "Pour les cartes MasterCard et Visa, vous trouverez le code à 3 chiffres au verso de votre carte, sur la zone de signature.",
	invalid_format: "Format non valide",
	invalid_card_detail: "Les coordonnées de la carte bancaire saisie ne sont pas valides. Merci de vérifier les informations.",
	pay_with_ideal: "Payer avec iDeal",
	pay_with_bancontact: "Payer avec Bancontact",
	choose_bank: "Sélectionnez votre banque",
	payment_error_popup_title: "Paiement refusé",
	payment_error_popup_text: "Désolé mais votre paiement vient d’être refusé. Veuillez réessayer ou contactez-nous au",
	confirmation_error_popup_phone: "04 79 96 30 69",
	confirmation_error_popup_phone_yoonly: "+32 2 808 25 70",
	payment_error_popup_button: "OK",
	make_quote: "Votre recherche de séjour",
	save_your_quote: "Sauvegarder votre recherche",
	devis_desc_1: "En sauvegardant votre recherche vous pourrez le retrouver sur votre espace personnel via la rubrique \"Mon compte Client\" pour procéder au paiement dès que vous le souhaitez.",
	devis_desc_4: "À noter :",
	devis_desc_5: "Vérifiez la disponibilité de votre séjour au moment de la réservation.",
	save: "Sauvegarder",
	payment_status_check_payment: "Vérification du paiement",
	payment_status_confirm_payment: "Confirmation du paiement",
	payment_status_check_availability: "Vérification de la disponibilité du logement",
	summary_accommodation_details: "Détails de l’hébergement",
	summary_package_total: "Votre package",
	summary_thanks_to_pack_you_save: "Grâce à votre package Travelski, vous économisez :",
	summary_fee: "Frais de service",
	summary_fee_WIYP: "Frais de service inclus",
	promocode: "Code promo ?",
	promocode_wrong: "Le code promotionnel que vous avez indiqué n’est pas valide",
	promocode_fnacdarty: "Offre réservée aux adhérents Fnac, aux abonnés Darty + et aux porteurs de la carte Visa Darty",
	promocode_macif: "Offre réservée aux Sociétaires MACIF",
	promocode_uneo: "Offre réservée aux adhérents UNEO",
	promocode_first_name: "Prénom",
	promocode_last_name: "Nom",
	promocode_last_6_digits: "6 derniers chiffres de votre n° de carte/abonné",
	promocode_date_of_birth: "Date de naissance (jj/mm/aaaa)",
	promocode_date_of_birth_day: "Jour",
	promocode_date_of_birth_month: "Mois",
	promocode_date_of_birth_year: "Année",
	promocode_mandatory_field: "Champs obligatoires",
	promocode_invalid_format: "Format incorrect",
	green_banner: "Avec votre réservation vous bénéficiez du meilleur prix garanti Travelski",
	summary_enter_code: "Saisissez votre code promotionnel",
	summary_validate: "Valider",
	summary_total: "Total",
	summary_book: "Passer à l’étape suivante",
	confirmation_status_reservation_title: "Félicitations !",
	confirmation_status_reservation_subtitle_1: "Votre séjour commence dans",
	confirmation_status_reservation_subtitle_2: "jours.",
	confirmation_reservation_1: "Vous allez recevoir d’ici quelques minutes la confirmation de votre séjour et celle de votre paiement.",
	confirmation_reservation_2: "Pour rappel, nous procédons ce jour au débit de",
	confirmation_reservation_3: "correspondant à",
	confirmation_reservation_4: "% du montant de votre séjour.",
	confirmation_reservation_5: "Le solde de votre commande, soit",
	confirmation_reservation_6: ", sera prélevé automatiquement",
	confirmation_reservation_7: ".",
	confirmation_reservation_8: "Retrouvez toutes ces informations sur votre compte Travelski. Vous pouvez vous connecter",
	confirmation_reservation_9: "ici",
	confirmation_reservation_10: ".",
	confirmation_by_phone: "Appeller un conseiller",
	confirmation_booking_100_percent_1: "Vous allez recevoir d’ici quelques minutes la confirmation de votre séjour et celle de votre règlement.",
	confirmation_booking_100_percent_2: "Pour rappel, nous procédons ce jour au débit de",
	confirmation_booking_100_percent_3: ", correspondant à 100% du montant de votre séjour.",
	confirmation_booking_100_percent_4: "Retrouvez toutes ces informations sur votre compte Travelski. Vous pouvez vous connecter",
	confirmation_booking_100_percent_5: "ici",
	confirmation_booking_100_percent_6: ".",
	confirmation_status_reservation_title_already_paid: "Vous avez déjà payé votre séjour.",
	confirmation_status_quote_title: "Votre recherche est sauvegardée",
	confirmation_status_quote_subtitle: "Pensez à finaliser votre réservation.",
	confirmation_quote_1: "Travelski vous remercie de votre confiance et a le plaisir de vous confirmer que votre recherche est sauvegardée.",
	confirmation_quote_2: "Référence :",
	confirmation_quote_3: "Une recherche sauvegardée n’est pas une réservation. Seul le versement d’un acompte ou le paiement intégral du montant du dossier vous assure de la disponibilité de votre séjour.",
	confirmation_reserve_quick: "Réservez vite !",
	go_back_to_booking: "Reprendre ma réservation",
	confirmation_status_error_title: "Une erreur est survenue",
	confirmation_error_1: "Nous sommes désolé, votre réservation n’a malheureusement pas pu être prise en compte. Nous vous invitons à réessayer ou à nous contactez au",
	confirmation_other_payment_method: "04 79 96 30 69",
	confirmation_error_1_sentence: "La réservation de votre séjour n’a malheureusement pas pu être prise en compte.",
	confirmation_unavailable_text: "Le séjour souhaité n`est malheureusement plus disponible. Veuillez réessayer ou contactez-nous au",
	confirmation_error_text: "Désolé mais votre paiement vient d’être refusé. Veuillez réessayer ou contactez-nous au",
	confirmation_error_phone: "04 79 96 30 69",
	confirmation_make_reservation_account_title: "Sur votre compte client :",
	confirmation_make_reservation_account: "Connectez-vous à la rubrique “Mon compte” pour retrouver votre recherche et bien plus encore",
	confirmation_make_reservation_account_button: "Accéder à mon compte",
	confirmation_make_reservation_phone_title: "Par téléphone :",
	confirmation_make_reservation_phone_1: "Appelez l’un de nos conseillers vacances au",
	confirmation_make_reservation_phone_2: "04 79 96 30 69",
	confirmation_status_unavailable_title: "Ce logement n’est plus disponible",
	confirmation_status_unavailable_subtitle: "Nous sommes désolés, le séjour que vous avez sélectionné n’est plus disponible.",
	confirmation_unavailable_1: "Le séjour que vous avez sélectionné n’est plus disponible car il vient d’être réservé par un autre internaute.",
	confirmation_unavailable_2: "Vous n’avez pas été débité.",
	confirmation_find_another: "Trouvez un autre séjour",
	confirmation_find_another_same_title: "Garder le même hébergement",
	confirmation_find_another_same_1: "C’est votre logement coup de cœur et vous êtes flexible ? Modifier les dates de séjour ou sélectionner une autre chambre.",
	confirmation_find_another_same_button: "Retourner sur la page du séjour",
	confirmation_find_another_other_title: "Rester dans la même station",
	confirmation_find_another_other_1: "Cette station est plébiscitée, mais nous sommes persuadés que vous pouvez trouver votre bonheur !",
	confirmation_find_another_other_button: "Nos autres séjours sur",
	confirmation_find_another_search_title: "Faire une nouvelle recherche",
	confirmation_find_another_search_1: "Malgré tous nos efforts, vous ne souhaitez pas poursuivre votre recherche sur cette station ?",
	confirmation_find_another_search_2: "Aucun soucis, Travelski propose des séjours dans 160 stations !",
	confirmation_find_another_search_button: "Faire une nouvelle recherche",
	confirmation_find_another_question_title: "Une question ? Un problème ?",
	confirmation_find_another_question_1: "04 79 96 30 69",
	confirmation_your_order: "Votre commande",
	confirmation_summary_details_button: "Détails de ma commande",
	confirmation_access_account: "Accéder à mon compte",
	tic_tac_trip_1: "Pour votre trajet, optez pour une solution douce",
	tic_tac_trip_2: "avec notre partenaire TicTacTrip.",
	tic_tac_trip_3: "En vous rendant en station pour votre séjour avec travelski en train, bus, covoiturage ou voiture électrique nous vous offrons",
	tic_tac_trip_4: "un avoir 120€* pour votre prochain séjour",
	tic_tac_trip_5: "dans les Alpes avec nous.",
	tic_tac_trip_6: "Réserver mon trajet",
	tic_tac_trip_7: "* un avoir de 120€ TTC par réservation est proposé sur présentation et validation par notre service client des justificatifs de voyage en train, covoiturage, bus ou voiture électrique pour tous les participants du séjour réservé auprès de travelski sur la saison hiver 2023/2024 et valable exclusivement pour l’achat d’un nouveau séjour packagé (hébergement et forfaits) au ski auprès de travelski réalisé avant le 30 avril 2025, cet avoir n’est pas cumulable avec d’autres codes promotionnels en cours de validité).",
	Transport_private: "Je choisis un transfert privé pour plus de confort et de flexibilité",
	Transport_arrival: "A l’arrivée, un chauffeur privé m’attendra à la gare pour m’amener jusqu’à mon hébergement.",
	Transport_return: "Au retour, un chauffeur m’attendra au pied de mon hébergement en station pour me ramener à la gare.",
	smile_and_pass: "Service Smile&Pass : votre forfait remis en même temps que les clés de votre hébergement",
	Transport_coaches: "Sièges spacieux avec prises de courant",
	Transport_meal: "Dîner et petit-déjeuner continental inclus dans le train aller; déjeuner et thé inclus dans le voyage de retour.",
	Transfer_private: "Je choisis un transfert privé pour plus de confort et de flexibilité",
	Transfer_bus: "Je choisis un transfert en autocar entre la gare et la station",
	snowboard_seul_argent_name: "Snowboard Seul Argent (Snowboard)",
	snowboard_seul_argent_description: "Je choisis du matériel polyvalent et ludique pour débuter ou progresser en snowboard",
	snowboard_seul_or_name: "Snowboard Seul Or (Snowboard)",
	snowboard_seul_or_description: "Je ride avec aisance et je choisis du matériel performant sur les pistes comme sur le snowpark",
	pack_argent_snowboard_name: "Pack Argent (Snowboard + Chaussures)",
	pack_argent_snowboard_description: "Je recherche du matériel polyvalent et ludique pour débuter ou progresser en snowboard",
	pack_or_snowboard_name: "Pack Or (Snowboard + Chaussures)",
	pack_or_snowboard_description: "Je ride avec aisance et je recherche du matériel performant sur les pistes comme sur le snowpark",
	skis_seuls_argent_name: "Skis Seuls Argent (Skis + Bâtons)",
	skis_seuls_argent_description: "Je débute le ski et je veux du matériel maniable pour m’amuser sur les pistes vertes et bleues",
	skis_seuls_or_name: "Skis Seuls Or (Skis + Bâtons)",
	skis_seuls_or_description: "Je suis à l’aise sur les pistes et je choisis du matériel pour évoluer sur l’ensemble du domaine",
	skis_seuls_platine_name: "Skis Seuls Platine (Skis + Bâtons).",
	skis_seuls_platine_description: "Je suis un bon skieur et je choisis d’un matériel technique et performant pour un maximum de plaisir",
	pack_eco_name: "Pack Eco (Skis + Chaussures + Bâtons)",
	pack_eco_description: "Je recherche du matériel à prix réduit quelque soit mon niveau",
	pack_argent_name: "Pack Argent (Skis + Chaussures + Bâtons)",
	pack_argent_description: "Je débute le ski et je veux du matériel maniable pour m’amuser sur les pistes vertes et bleues",
	pack_or_name: "Pack Or (Skis + Chaussures + Bâtons)",
	pack_or_description: "Je suis à l’aise sur les pistes et je recherche du matériel pour évoluer sur l’ensemble du domaine",
	pack_platine_name: "Pack Platine (Skis + Chaussures + Bâtons)",
	pack_platine_description: "Je suis un bon skieur et je suis à la recherche d’un matériel technique et performant pour un maximum de plaisir",
	pack_mini_kid_ski_name: "Pack Mini Kid 2-5 ans (Skis + Chaussures)",
	pack_mini_kid_ski_description: "Mon enfant s’initie à la glisse avec du matériel léger et souple pour progesser rapidement",
	pack_espoir_skis_name: "Pack Espoir 6-11 ans (Skis + Chaussures + Bâtons)",
	pack_espoir_skis_description: "Idéal jusqu’à la 3ème étoile, mon enfant skie en toute sécurité avec du matériel adapté à sa morphologie.",
	pack_champion_skis_name: "Pack Champion 6-11 ans (Skis + Chaussures + BÃ¢tons)",
	pack_champion_skis_description: "Très à l’aise sur ses skis, votre enfant a besoin de skis performants et fiables pour continuer de progresser",
	pack_espoir_snowboard_name: "Pack Espoir 6-11 ans (Snowboard + Chaussures)",
	pack_espoir_snowboard_description: "Mon enfant veut découvrir le snowboard avec du matériel mis au point pour les jeunes riders",
	pack_champion_snowboard_name: "Pack Champion 6-11 ans (Snowboard + Chaussures)",
	pack_champion_snowboard_description: "Mon enfant veut découvrir le snowboard avec du matériel adapté aux jeunes riders",
	panier_enfant_name: "Panier Enfant (-12 ans)",
	panier_enfant_description: "Burger, Nuggets, Vache qui Rit, Compotes… Je me simplifie les vacances en me faisait livrer de quoi préparer des repas qui plairont à mon enfant et qui lui donneront de l’énergie sur les pistes.",
	panier_enfant_hallal_name: "Panier Enfant Hallal (-12 ans)",
	panier_enfant_hallal_description: "Burger, Nuggets, Vache qui Rit, Compotes… Je me simplifie les vacances en me faisait livrer de quoi préparer des repas qui plairont à mon enfant et qui lui donneront de l’énergie sur les pistes tout en respectant mes spécificités religieuses.",
	panier_hallal_name: "Panier Hallal",
	panier_hallal_description: "Je choisis la simplicité en me faisait livrer de quoi préparer tous les petits déjeuners, les pique-niques sur les pistes et 6 dîners complets avec de produits classiques et simples à préparer tout en respectant mes spécificités religieuses.",
	panier_gourmand_name: "Panier Gourmand",
	panier_gourmand_description: "Je choisis la simplicité en me faisait livrer de quoi préparer tous les petits déjeuners, les pique-niques sur les pistes et 6 dîners complets avec de produits classiques et simples à préparer.",
	panier_gastronomique_name: "Panier Gastronomique",
	panier_gastronomique_description: "Je profite de mes vacances en me faisant livrer de quoi préparer tous les petits déjeuners, les pique-niques sur les pistes et 6 dîners avec des produits de qualité, des plats traiteurs le tout avec un touche savoyarde dans mes assiettes.",
	global_insurance_conditions: "Voir les conditions de l’assurance",
	contacts_incorrect_credentials: "Vos identifiants sont incorrects",
	voir_le_detail_de_mon_trajet: "Voir le détail de mon trajet",
	i_dont_want: "Je ne souhaite pas de",
	login_page_title: "Compte Client",
	accommodation_popup: "Détails de l’hébergement",
	liheDesc_included: "Services proposés",
	planner_what_is_included: "Qu’est-ce qui est inclus ?",
	productDesc_advantage: "Les plus du séjour",
	planner_prestationsAppartmentEquipment: "Équipements de l’appartement :",
	planner_prestationsPrivateBathroom: "Dans votre salle de bains privative :",
	planner_prestationsPrivateKitchen: "Dans votre cuisine privative :",
	planner_prestationsPrivateServices: "Services proposés :",
	prestation_floorNumber: "Etage",
	criteria_354: "16 pièces",
	criteria_353: "15 pièces",
	criteria_352: "14 pièces",
	criteria_351: "13 pièces",
	criteria_350: "12 pièces",
	criteria_349: "11 pièces",
	criteria_348: "10 pièces",
	criteria_347: "9 pièces",
	criteria_346: "8 pièces",
	criteria_345: "7 pièces",
	criteria_344: "6 pièces",
	criteria_343: "5 pièces",
	criteria_342: "4 pièces",
	criteria_341: "3 pièces",
	criteria_340: "2 pièces",
	criteria_339: "1 pièce",
	criteria_338: "20 chambres",
	criteria_337: "19 chambres",
	criteria_336: "18 chambres",
	criteria_335: "17 chambres",
	criteria_334: "16 chambres",
	criteria_333: "15 chambres",
	criteria_332: "14 chambres",
	criteria_331: "13 chambres",
	criteria_330: "12 chambres",
	criteria_329: "11 chambres",
	criteria_328: "10 chambres",
	criteria_327: "9 chambres",
	criteria_326: "8 chambres",
	criteria_325: "7 chambres",
	criteria_324: "6 chambres",
	criteria_323: "5 chambres",
	criteria_322: "4 chambres",
	criteria_321: "3 chambres",
	criteria_320: "2 chambres",
	criteria_319: "1 chambre",
	criteria_985: "5 lits doubles",
	criteria_982: "4 lits doubles",
	criteria_983: "3 lits doubles",
	criteria_762: "2 lits doubles",
	criteria_741: "1 lit double",
	criteria_987: "10 lits simples",
	criteria_986: "9 lits simples",
	criteria_988: "8 lits simples",
	criteria_984: "7 lits simples",
	criteria_767: "6 lits simples",
	criteria_766: "5 lits simples",
	criteria_765: "4 lits simples",
	criteria_764: "3 lits simples",
	criteria_763: "2 lits simples",
	criteria_742: "1 lit simple",
	criteria_769: "4 lits superposés",
	criteria_768: "2 lits superposés",
	criteria_743: "1 lit superposé",
	criteria_747: "Canapé-lit double",
	criteria_771: "2 canapés-lits",
	criteria_745: "Canapé-lit",
	criteria_744: "1 lit gigogne",
	criteria_46: "Lit Bébé (sur demande)",
	criteria_746: "Canapé",
	criteria_29: "Balcon/Terrasse",
	criteria_773: "Balcons",
	criteria_739: "Balcon",
	criteria_738: "Terrasse",
	criteria_761: "Mezzanine",
	criteria_30: "Rez-de-jardin",
	criteria_55: "Wifi disponible",
	criteria_27: "Télévision",
	criteria_23: "Lave-linge",
	criteria_803: "Sèche-linge",
	criteria_47: "Kit Bébé (sur demande)",
	criteria_799: "Kit d’entretien",
	criteria_48: "Barbecue",
	criteria_25: "Climatisation",
	criteria_981: "Toilettes séparés",
	criteria_31: "Personne à mobilité réduite (PMR)",
	criteria_705: "Cuisine équipée",
	criteria_757: "Cuisine séparée",
	criteria_22: "Lave-vaisselle",
	criteria_756: "Réfrigérateur",
	criteria_759: "Plaque de cuisson",
	criteria_750: "Four",
	criteria_758: "Micro-ondes",
	criteria_752: "Machine à café",
	criteria_754: "Bouilloire",
	criteria_755: "Grille pain",
	criteria_715: "Douche",
	criteria_714: "Baignoire",
	criteria_748: "Linge de lit",
	criteria_45: "Linge de toilette",
	criteria_801: "Lits faits à l’arrivée",
	criteria_51: "Ménage en fin de séjour",
	criteria_76: "Piscine privée",
	criteria_75: "Piscine couverte",
	criteria_74: "Piscine extérieure",
	criteria_74_76: "Piscine privée extérieure",
	criteria_75_76: "Piscine privée couverte",
	criteria_71: "Spa",
	criteria_733: "Salle de remise en forme (fitness)",
	criteria_69: "Hammam",
	criteria_70: "Sauna",
	criteria_732: "Bain à remous",
	criteria_36: "Parking disponible",
	criteria_37: "Parking disponible",
	criteria_798: "Ascenseur",
	criteria_979: "Club Enfant",
	criteria_815: "100% - 18-35 ANS",
	criteria_52: "Animaux admis",
	criteria_800: "Casier à skis",
	criteria_980: "Bagagerie",
	criteria_312: "A proximité des commerces",
	criteria_807: "A 50 m des commerces",
	criteria_808: "A 100 m des commerces",
	criteria_306: "A 200 m des commerces",
	criteria_307: "A 500 m des commerces",
	criteria_308: "A 1 km des commerces",
	criteria_309: "A plus de 1 km des commerces",
	criteria_310: "A plus de 1 km des commerces",
	criteria_311: "A plus de 1 km des commerces",
	criteria_365: "Proche ESF",
	criteria_720: "A 50 m de l’ESF",
	criteria_721: "A 100 m de l’ESF",
	criteria_359: "A 200 m de l’ESF",
	criteria_360: "A 500 m de l’ESF",
	criteria_361: "A 1 km de l’ESF",
	criteria_362: "A plus de 1 km de l’ESF",
	criteria_363: "A plus de 1 km de l’ESF",
	criteria_364: "A plus de 1 km de l’ESF",
	criteria_305: "Au centre de la station",
	criteria_718: "A 50 m du centre",
	criteria_719: "A 100 m du centre",
	criteria_299: "A 200 m du centre",
	criteria_300: "A 500 m du centre",
	criteria_301: "A 1 km du centre",
	criteria_302: "A plus de 1 km du centre",
	criteria_303: "A plus de 1 km du centre",
	criteria_304: "A plus de 1 km du centre",
	criteria_291: "Au pied des pistes",
	criteria_716: "A 50 m des pistes",
	criteria_717: "A 100 m des pistes",
	criteria_285: "A 200 m des pistes",
	criteria_822: "A 300 m des pistes",
	criteria_286: "A 500 m des pistes",
	criteria_287: "A 1 km des pistes",
	criteria_288: "A plus de 1 km des pistes",
	criteria_289: "A plus de 1 km des pistes",
	criteria_290: "A plus de 1 km des pistes",
	criteria_60: "Service restauration",
	criteria_61: "Service restauration",
	criteria_62: "Service restauration",
	criteria_63: "Service restauration",
	criteria_64: "Service restauration",
	criteria_65: "Service restauration",
	criteria_67: "Service restauration",
	criteria_66: "Service restauration",
	criteria_700: "Réservez vos forfaits et récupérez-les lors de la remise des clés",
	food_image_criteria_1025: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_new.jpg",
	food_image_criteria_1025_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_mobile_new.jpg",
	food_image_criteria_1024_1025: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_new.jpg",
	food_image_criteria_1024_1025_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_mobile_new.jpg",
	food_image_criteria_1023: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_new.jpg",
	food_image_criteria_1023_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_mobile_new.jpg",
	food_image_criteria_1024: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
	food_image_criteria_1024_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
	food_image_criteria_1023_1024: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
	food_image_criteria_1023_1024_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
	food_image_criteria_1021: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_new.jpg",
	food_image_criteria_1021_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_mobile.jpg",
	food_image_criteria_1067: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner.png",
	food_image_criteria_1067_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner_mobile.png",
	food_image_criteria_1069: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension.png",
	food_image_criteria_1069_mobile: "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension_mobile.png",
	session_expired: "Votre session est sur le point d`expirer. Veuillez cliquer ici pour continuer.",
	reload_page: "Actualiser"
}
